module.exports = __webpack_public_path__ + "static/media/banner2.f7ea8a07.jpeg";